<script setup lang="ts">
import { useHead } from "@unhead/vue";
useHead({ title: "Page not found — MySimpleBible", meta: [{ name: "robots", content: "noindex" }] });
</script>

<template>
  <!--
    This page used the site's own vocabulary for two classes it does not own:
    `grid-field` and `section-label` are defined in no stylesheet, so the eyebrow
    rendered as unstyled 16px body text and the background field never appeared.
    It also set its headline with Tailwind's `text-7xl sm:text-9xl` — the one
    heading on the site outside the shared `--type-*` scale, and at 8rem it broke
    "index." mid-word inside a 320px column. Both are now the real site classes.
  -->
  <section class="notfound-band">
    <div class="notfound-copy">
      <p class="eyebrow">Page 404</p>
      <h1>Not in this index.</h1>
      <p class="notfound-lede">The address does not match a public MySimpleBible page.</p>
      <RouterLink to="/" class="button button--primary">Return home</RouterLink>
    </div>
  </section>
</template>

<style scoped>
.notfound-band {
  display: grid;
  min-height: 70vh;
  padding: clamp(4rem, 10vw, 8rem) var(--band-inline);
  place-items: center;
  text-align: center;
}

.notfound-copy {
  width: 100%;
  max-width: 40rem;
}

.notfound-copy h1 {
  margin: 1.5rem 0 0;
  font-family: var(--font-display);
  /* The shared scale, so the 404 heading answers the reader's text setting like
   * every other h1 and stays inside a 320px column at 150%. */
  font-size: var(--type-h1);
  font-weight: 800;
  letter-spacing: -0.05em;
  line-height: 0.98;
}

.notfound-lede {
  margin: 1.5rem auto 0;
  max-width: 34rem;
  color: rgb(23 16 33 / 0.66);
  font-size: clamp(1.05rem, 0.57rem + 0.75vw, 1.25rem);
  line-height: 1.7;
}

.notfound-copy .button {
  margin-top: 2.5rem;
}
</style>
